import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazyload";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
const Newsletter = () => {
  useEffect(() => {
    document.title = "Newsletter -  St Peters convent School Faridabad Haryana";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>
          </li>
          <li> Newsletter</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Newsletter </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
              <div className="video-gallery">
                <Link
                  // to="https://drive.google.com/file/d/1uR1h-6vcQTS3gq9hxfZKgdHj2bXcgKtw/view?usp=drive_link"
                  to="https://drive.google.com/file/d/1AadqGB5QQZ4cv6KuTvxOI_iLKIcTwm1D/view?usp=drive_link"
                  target="_blank">
                  <LazyLoad>
                    <img
                      src="https://webapi.entab.info/api/image/STPSFH/public/Images/newsletter_2.JPG"
                      alt="Gallery Placeholder"
                      className="img-fluid"
                    />
                  </LazyLoad>
                  <div>
                    <h3> Learning Today,Leading Tomorrow </h3>
                  </div>
                </Link>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
              <div className="video-gallery">
                <Link
                  to="https://drive.google.com/file/d/15X8EoUWe1fRwFfbmVc9f9g396qewrJS2/view"
                  target="_blank">
                  <LazyLoad>
                    <img
                      src="https://webapi.entab.info/api/image/STPSFH/public/Images/Newsletter1.jpg"
                      alt="Gallery Placeholder"
                      className="img-fluid"
                    />
                  </LazyLoad>
                  <div>
                    <h3> Little Steps Big dreams 2024-25 </h3>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Newsletter;
